import {metrics} from './utils/metrics.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import '@tabler/icons-webfont/dist/tabler-icons.min.css'; // the `ti ti-*` icon font, was never loaded; every icon in the app was invisible until 2026-08-11
import './theme.css';
import './heliograph.css';
import App from './App.jsx';

// The 3D Earth uses the self-hosted NASA Blue Marble texture.

metrics.enter('globe');

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
